export const LIMITS = [9, 18, 27, 36, 45]

export const PARAMS = {
  LIMIT: 1000,
  OFFSET: 0
}
